<template>
  <div> 

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

<!--___________Form_____________ -->
    <v-card>
      <!-- {{formSchema}}  -->
      <v-btn color="primary" v-on:click="printdiv" style="float:right">
        <v-icon>print</v-icon> Print
      </v-btn>

    <br>
    <div id="print-area">
      <table class="paySchedule top">
        <tbody>
          <tr class="textCenter">
            <th>Loan No</th>
            <th colspan="2" style="font-size: 16px;">{{ formSchema.loan_no }}</th>
          </tr>
          <tr class="tb-td">
            <th>Reschedule No</th>
            <th style="font-size: 16px;"> {{ (formSchema.new_re_schedule_no) }} </th>
          </tr>
          <tr class="tb-td">
            <th>Adjustment Type</th>
            <th style="font-size: 16px;">  Re-Schedule </th>
          </tr>
        </tbody>
      </table>


      <table class="paySchedule">
        <tbody v-if="formSchema.unpaid_installment && formSchema.unpaid_installment.length>0">
          <tr class="textCenter">
            <th colspan="5" style="font-size: 20px;">Unpaid Installment Calculation</th>
          </tr>
          <tr class="tb-td">
            <th>Due Installment Date</th>
            <th> Installment Size</th>
            <th>Over Due Days</th>
            <th>Over Due Interest</th>
            <th> Total Installment </th>
          </tr>
          <!-- __________________ Debit Row _________________ -->
          <tr v-for="(inst_data, index) in formSchema.unpaid_installment" :key=index>
            
            <td class="textCenter">
              {{dateStringMonth(inst_data.installment_date)}}
            </td>
            <td class="textCenter">
              {{inst_data.intallmentSize | currency}}
            </td>
            <td class="textCenter">
              {{ inst_data.total_Days }}
            </td>
            <td class="textCenter">
              {{inst_data.dueInterest | currency}}
            </td>
            <td class="textCenter">
              {{inst_data.total_size | currency}}
            </td>
          </tr>
          <!-- __________________ /Debit Row _________________ -->
          <tr >
            <th colspan="4" class="textRight">Total Due Installment</th>
            <th> {{formSchema.sum_installment | currency}} </th>
          </tr>


        </tbody>
      </table>
      <br>
      <table class="paySchedule">
        <tbody v-if="formSchema.partialPayData && formSchema.partialPayData.length>0">
          <tr class="textCenter">
            <th colspan="5" style="font-size: 20px;">Adjust Partial Payment</th>
          </tr>
          <tr class="tb-td">
            <th>Recieve Date</th>
            <th>Pay Amount</th>
            <th>Total Days</th>
            <th> Reduce Interest Amount </th>
            <th> Total Partial Pay Amount </th>
          </tr>
          <!-- __________________ Debit Row _________________ -->
          <tr v-for="(pay_data, index) in formSchema.partialPayData" :key=index>
            
            <td class="textCenter">
              {{dateStringMonth(pay_data.receive_date )}}
            </td>
            <td class="textCenter">
              {{pay_data.payAmount | currency}}
            </td>
            <td class="textCenter">
              {{ pay_data.totalDay }}
            </td>
            <td class="textCenter">
              {{pay_data.reduceInterest | currency}}
            </td>
            <td class="textCenter">
              {{pay_data.total_partial_amount | currency}}
            </td>
          </tr>
          <!-- __________________ /Debit Row _________________ -->
          <tr >
            <th colspan="4" class="textRight">Total Partial Pay Amount</th>
            <th> {{ (formSchema.partialPayData) ? formSchema.partialPayData[0].sum_partial_amount : 0 | currency}} </th>
          </tr>


        </tbody>
      </table>
      <br>
      <table class="paySchedule">
        <tbody>
          <tr class="textCenter">
            <th colspan="8" style="font-size: 20px;"> Outstanding Calculation </th>
          </tr>
          <tr class="tb-td">
            <th>Last Installment Date</th>
            <th> Outstanding <br> (A) </th>
            <th style="padding:0px;">Extra Days</th>
            <th> Extra Interest <br> (B) </th>
            <th> Due Installment <br> (C) </th>
            <th> Partial Amount <br> (D) </th>
            <th>Total Outstanding <br> (A+B+C)-(D)</th>
          </tr>
          <!-- __________________ Debit Row _________________ -->
          <tr>
            
            <td class="textCenter">
              {{dateStringMonth(formSchema.lastInstallment_date)}}
            </td>
            <td class="textCenter">
              {{formSchema.principal | currency}}
            </td>
            <td class="textCenter">
              {{ formSchema.total_Days }}
            </td>
            <td class="textCenter">
              {{formSchema.extra_interest | currency}}
            </td>
            <td class="textCenter">
              {{formSchema.sum_installment | currency}}
            </td>
            <td class="textCenter">
              {{(formSchema.partialPayData && formSchema.partialPayData.length > 0) ? formSchema.partialPayData[0].sum_partial_amount : 0 | currency}}
            </td>
            <td class="textCenter">
              {{formSchema.outstanding | currency}}
            </td>
          </tr>
          <!-- __________________ /Debit Row _________________ -->

        </tbody>
      </table>
      <br>
    </div>  
          

    <!-- Confirmation box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmDialog" max-width="800">
        <v-card>
          <v-card-title>
            <span class="headline">Is your information correct?</span>
          </v-card-title>
          <hr>
          <!-- {{changeFormateDMY(formSchema.reset_date)}} -->
          <v-card-text>
            <table class="reSchedult">
              <tr>
                <td>Loan Number</td>
                <td>&nbsp; : &nbsp;</td>
                <td colspan="5" style="font-weight: 600;">{{formSchema.loan_no}}</td>
              </tr>

              <tr>
                <td>Sub-Project Name</td>
                <td>&nbsp; : &nbsp;</td>
                <td colspan="5" style="font-weight: 600;">{{formSchema.sub_project_name}}</td>
              </tr>

              <tr>
                <td>Old Re Schedule Date</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{changeFormateDMY(formSchema.re_schedule_date)}}</td>
                <td style="width:100px;">&nbsp;&nbsp;</td>
                <td>New Re Schedule Date</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{changeFormateDMY(formSchema.new_re_schedule_date)}}</td>
              </tr>

              <tr>
                <td>Old Re Schedule No.</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.re_schedule_no}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>New Re Schedule No.</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.new_re_schedule_no}}</td>
              </tr>

              <tr>
                <td>Old Interest Rate</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.interest_rate}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>New Interest Rate</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.new_interest_rate}}</td>
              </tr>

              <tr>
                <td>Old No of Installment</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.no_of_installment}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>New No of Installment</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.new_no_of_installment}}</td>
              </tr>

              <tr>
                <td>Old Grace Period (In Month)</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.old_grace_period_in_month}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>Manual Grace Period (In Month)</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.sub_grace_period_in_month}}</td>
              </tr>

              <tr>
                <td>Old Installment Type</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.OldIntallMentTypeName}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>New Installment Type</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.NewIntallMentTypeName}}</td>
              </tr>

              <tr>
                <td>Old Interest By Month</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.interest_by_month}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>Interest Reset Frequently(By Month)</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.new_interest_by_month}}</td>
              </tr>


               <tr>
                <td>Old Repayment Start Date</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.repayment_start_date}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>New Repayment Start Date</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.new_repayment_start_date}}</td>
              </tr>

              <tr>
                <td>Outstanding Amount</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.outstanding_amount}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>Overdue Interest</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.overdue_amount}}</td>
              </tr>

              <tr>
                <!-- <td colspan="4"></td> -->
                <td>New Loan Amount</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.loan_amount}}</td>
                <td>&nbsp;&nbsp;</td>
                <td>Down Payment</td>
                <td>&nbsp; : &nbsp;</td>
                <td>{{formSchema.down_payment}}</td>
              </tr>

            </table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.native="confirmDialog = false">
              No
            </v-btn>
            <v-btn color="success" @click.native="submitForm">
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation box -->
<!-- {{formSchema}} -->
      <v-card-title class="pb-0">
        <span class="headline">Loan Re-Schedule Interest</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation class="mt-0">
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Old Re Schedule Date" 
                v-model="formSchema.re_schedule_date"                
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'new_re_schedule_date', fieldValue:formSchema.new_re_schedule_date, label:'New Re-Schedule Date', required:'1', minVal:formSchema.re_schedule_date,currentDate:'1'}"
                @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Old Re Schedule No." 
                v-model="formSchema.re_schedule_no" 
                type="number"
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="New Re Schedule No." 
                v-model="formSchema.new_re_schedule_no" 
                type="number"
                :rules="[v => !!v || 'New Re Schedule no is required !']"
                required
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Old Interest Rate"
                v-model="formSchema.interest_rate"
                :rules="[v => !!v || 'Old Interest rate is required !',lng11]"
                required
                readonly
                type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="New Interest Rate"
                v-model="formSchema.new_interest_rate"
                :rules="[v => !!v || 'New interest rate is required !',lng11]"
                required
                type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Remaining No. of Installment"
                v-model="formSchema.no_of_installment"
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="New No. of Installment"
                v-model="formSchema.new_no_of_installment"
                :rules="[v => !!v || 'New no of installment is required !',lng11]"
                required
                @input="ChangeInstType"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Old Grace Period (In Month)"
                v-model="formSchema.old_grace_period_in_month"
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Grace Period (In Month)"
                v-model="formSchema.grace_period_in_month"
                :rules="[v => !!v || 'Field is required !']"
                @input="repaumentDate(formSchema.grace_period_in_month)"
                required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="Interest Pay in Grace Period"
                v-model="formSchema.interestPay_InGracePeriod"
                :items="['With Interest Payment', 'Without Interest Payment']"
                :rules="[
                  (v) => !!v || 'Interest pay in grace period is required !',
                ]"
                @input="changeGracePeriod(formSchema.interestPay_InGracePeriod)"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Grace Period With Interest (In Month)"
                v-model="formSchema.sub_grace_period_in_month"
                :readonly="PeriodTrue"
              ></v-text-field>
            </v-flex>


              <v-flex xs12 sm6 md6>  
                {{ getInstallmentTypeNameById(formSchema.installment_type_id) }}
                <v-text-field
                label="Old Installment Type"
                v-model="oldInstallmentTypeName"
                readonly
                ></v-text-field>
                <input type="hidden" v-model="oldInstallmentTypeName" readonly>   
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                label="New Installment Type"
                item-text="installment_type"
                item-value="id"
                v-model="formSchema.new_installment_type_id"
                :items="InstallmentTypeIdList"
                :rules="[v => !!v || 'New installment type is required !',lng11]"
                required
                @input="ChangeInstType"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Old Interest By Month" v-model="formSchema.interest_by_month" 
                type="number"
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Interest Rate Reset Frequency(By Month)" v-model="formSchema.new_interest_by_month" 
                type="number"
                @input="ChangeInstType"
                :rules="[v => !!v || 'Field is required !']"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Old Repayment Start Date" 
                v-model.number="formSchema.repayment_start_date"
                readonly
                ></v-text-field>
              </v-flex>

               <v-flex xs12 sm6 md6>
                 <v-text-field
                  label="New Repayment Start Date / Loan Date"
                  v-model="formSchema.new_repayment_start_date"
                  readonly
                ></v-text-field>
                <!-- <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'new_repayment_start_date', 
                  fieldValue:formSchema.new_repayment_start_date, 
                  label:'New Repayment Start Date / Loan Date', 
                  required:'1',minVal:formSchema.re_schedule_date}"
                @setValue="setDateValue"
                ></DatePicker> -->
              </v-flex>

              <!-- <v-flex xs12 sm6 md6>
                <v-text-field label="Old Reset Date" 
                v-model="formSchema.reset_date" 
                :rules="[v => !!v || 'Reset date is required !']"
                required
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'new_reset_date', fieldValue:formSchema.new_reset_date, label:'New Reset Date', required:'1'}"
                @setValue="setDateValue"
                ></DatePicker>
              </v-flex> -->

              <v-flex xs12 sm6 md6 >
                <v-text-field label="Outstanding Amount" v-model="formSchema.outstanding_amount" 
                :rules="[v => !!v || 'New installment type is required !',lng30]"
                required
                type="number"
                readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6 >
                <v-text-field label="Overdue Interest Rate" v-model="formSchema.overdue_amount" 
                :rules="[v => !!v || 'Overdue interest is required !',lng30]"
                required
                type="number"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6 >
                <v-text-field label="Loan Amount" v-model="formSchema.loan_amount" 
                :rules="[lng30]" 
                type="number"
                readonly
                ></v-text-field> 
              </v-flex>  

              <v-flex xs12 sm6 md6 >
                <v-text-field label="Down Payment" v-model="formSchema.down_payment" 
                :rules="[lng30]"                
                type="number"
                @input="changeOverdueAmt"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field label="Check Number" 
                v-model.number="formSchema.check_number"
                :rules="checkNumber"
                required
                ></v-text-field>
              </v-flex>

               <v-flex xs12 sm6 md6>

                <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'check_date', fieldValue:formSchema.check_date, label:'Check Date', required:checkDateRequired}"
                @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              </v-layout>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" v-if="saveBtn" @click.native="confirmation" :disabled="!valid">
                  <v-icon>save</v-icon>
                  Submit
                </v-btn>
                <v-btn color="error" @click="previous">
                  <v-icon>arrow_back_ios</v-icon>Previous
                </v-btn>
              </v-card-actions>

            </v-container>
          </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/Form_____________ -->

  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

import Axios from "axios";

export default {
  components: {
   DatePicker 
  },

  data: () => ({
    valid: true,
    saveBtn:true,

    checkNumber:[],
    checkDateRequired:0,

    leaveTypeModal: false,
    detailObject:'',
    confirmDialog:false,
    EcoCodeInfoList:[],
    DisbursementAccountList:[],
    PeriodTrue: true,
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    oldInstallmentTypeName:'',
    InstallmentTypeIdList: [],

    formSchema:{
      re_schedule_date:'',
      new_re_schedule_date:'',
      re_schedule_no:'',
      new_re_schedule_no:'',
      interest_rate:'',
      new_interest_rate:'',
      no_of_installment:'',
      new_no_of_installment:'',
      installment_type:'',
      new_installment_type:'',
      installment_type_id:'',
      new_installment_type_id:'',

      old_grace_period_in_month:'',
      sub_grace_period_in_month:'',
      interestPay_InGracePeriod:'',

      interest_by_month:'',
      new_interest_by_month:'',

      reset_no:'',
      new_reset_no:'',
      outstanding_amount:'',
      overdue_amount:'',
      down_payment:'',
      loan_amount:'',            
    },

    debit:
    {          
      eco_code_id:'',
      eco_code:'',
      account_name:'',
      tr_debit:'',
      tr_credit:'',
      currency:'',
      bdt_debit:'',
      bdt_credit:'',
      usd_debit:'',
      usd_credit:'',
      src_fund: '',
      loan_no:'',
      amount_type:"Ins",
    },

    credit:
    {
      eco_code_id:'',
      eco_code:'',
      account_name:'',
      tr_debit:'',
      tr_credit:'',
      currency:'',
      bdt_debit:'',
      bdt_credit:'',
      usd_debit:'',
      usd_credit:'',
      src_fund: '',
      loan_no:'',
      amount_type:"D",
    },
    
  }),

  created(){  

    let info = this.$store.getters.GET_COMMON_DATA;  
   // let partialPayment = this.$store.getters.GEE_KEY_VALUE;  
    console.log('info = ', info);

    if(info)
    {
      this.DisbursementAccountList.push(info.disbursement_accountInfo);
      this.formSchema = info;

      this.formSchema.repayment_start_date = (info.repayment_start_date !== '0000-00-00' ) ? this.changeFormateDMY(info.repayment_start_date) : "";

      this.formSchema.old_grace_period_in_month = info.grace_period_in_month;      
      this.formSchema.grace_period_in_month = '';      

      let reScheduleDate = '';
      if(info.re_schedule_date !== '0000-00-00')
      {
        reScheduleDate = this.changeFormateDMY(info.re_schedule_date);
      }
      this.formSchema.re_schedule_date = reScheduleDate; 
  
      let newReScheduleDate = '';
      if(info.new_re_schedule_date !== '0000-00-00')
      {
        newReScheduleDate = this.changeFormateDMY(info.new_re_schedule_date);
      }
      this.formSchema.new_re_schedule_date = newReScheduleDate;
           
      this.formSchema.new_repayment_start_date = newReScheduleDate;  

      this.formSchema.outstanding_amount =(info.old_opening_principal) ? this.numberFormate(info.old_opening_principal) :'';
      
      this.formSchema.new_re_schedule_no = Number(info.re_schedule_no) + 1;
      this.formSchema.new_interest_by_month  = this.formSchema.interest_by_month;
      //this.formSchema.overdue_amount = this.formSchema.overdue_interest_rate;

      let overdue_amount = this.formSchema.overdue_amount;
      let down_payment = this.formSchema.down_payment;

      //this.formSchema.loan_amount = this.numberFormate(parseFloat(info.outstanding_amount) + parseFloat(overdue_amount||0) + parseFloat(down_payment||0));
      this.formSchema.loan_amount = this.numberFormate(parseFloat(info.outstanding_amount) + parseFloat(down_payment||0));

      commonService.getAllData("get-dis-dropdown-data").then(res => {        
        this.EcoCodeInfoList = res.EcoCodeInfoList;
      });

      commonService.getAllData("get-dropdown-data-for-load-profile").then(res => {
        this.InstallmentTypeIdList = res.InstallmentTypeIdList;
      });
    }
    
    if(!this.formSchema.loan_id)
    {
      this.$router.push("/on-lending/search-loan-reschedule");
    }
  },

  methods: {

    changeGracePeriod(val) {
      console.log("val", val);
      if (val == "With Interest Payment") {
        this.PeriodTrue = false;
      } else {
        this.PeriodTrue = true;
        this.formSchema.sub_grace_period_in_month = '';
      }
    },

    repaumentDate(val){
      var scheduleDate = this.changeFormateYMD(this.formSchema.new_re_schedule_date);
      scheduleDate = new Date(scheduleDate);
      let tempdate = scheduleDate.setMonth(scheduleDate.getMonth() + Number(val));
      let nextResetdate = new Date(tempdate);
      nextResetdate = nextResetdate.toJSON().substring(0, 10);
      this.formSchema.new_repayment_start_date = this.changeFormateDMY(nextResetdate);
      //console.log(this.formSchema.new_repayment_start_date);
    },

    getInstallmentTypeNameById(id){
      this.InstallmentTypeIdList.forEach(el => {
        if(el.id == id){          
          this.oldInstallmentTypeName = el.installment_type
        }
      });
      
    },

    submitForm() {
      let root = this

      var formSchema = this.formSchema; 
      formSchema.formName = 'Re-Schedule';

      

      //formSchema.formName = 4; //Re-Schedule


      /*formSchema.interest_rate = formSchema.new_interest_rate;
      formSchema.new_reset_date = this.changeFormateDMY(
              formSchema.new_reset_date
            );

      formSchema.reset_no = formSchema.reset_no+1;
      formSchema.loan_amount = formSchema.old_opening_principal;
      formSchema.old_opening_principal = formSchema.old_opening_principal;*/

      //formSchema.old_opening_principal = formSchema.old_opening_principal

      formSchema.loan_date = '';
      console.log('formSchema', formSchema);
      this.$store.commit('SET_COMMON_DATA', formSchema);
      this.$router.push("/on-lending/loan-profile-stepform");   


      //formSchema.currency = formSchema.transaction_currency

      //formSchema.disbursement_date = this.changeFormateYMD(formSchema.disbursement_date);
      /*parseFloat(formSchema.interest_rate).toFixed(2);
      
      let formData = new FormData();

      formData.append("formSchema", JSON.stringify(this.formSchema));
      formData.append("debit", JSON.stringify(this.debit));
      formData.append("credit", JSON.stringify(this.credit));

        commonService
          .insertFormData(formData, "loan-disbursement")
          .then(res => {

            if(res.status == 1)
            {       
              this.saveBtn = false;       
              this.SnackbarVal.color = "success"
              this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');
              this.confirmDialog = false;
            }
            else
            {
              this.SnackbarVal.color = "error"
            }
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;

            setTimeout(function() {
              root.$router.push("/on-lending/search-disbursement");       
            }, 3000);

          });*/
    },

    // confirmation() {
    //   let formSchema = this.formSchema      
    //   if (this.$refs.form.validate()) {
    //    let InstType = this.InstallmentTypeIdList.filter(function (a) 
    //     {  
    //       return a.id === formSchema.installment_type_id
    //     })[0];

    //    formSchema.OldIntallMentTypeName = InstType.installment_type
       
    //    let InstType2 = this.InstallmentTypeIdList.filter(function (a) 
    //     {  
    //       return a.id === formSchema.new_installment_type_id
    //     })[0];

    //    formSchema.NewIntallMentTypeName = InstType2.installment_type
       
      
    //     this.confirmDialog = true;  
    //   }
    // },

    confirmation() {
      let formSchema = this.formSchema      
      if (this.$refs.form.validate()) {

      this.InstallmentTypeIdList.forEach(el => {
        if(el.id == formSchema.installment_type_id){                    
          formSchema.OldIntallMentTypeName = el.installment_type
        }
        if(el.id == formSchema.new_installment_type_id){                    
          formSchema.NewIntallMentTypeName = el.installment_type
        }
      });

        this.confirmDialog = true;  

      }
    },

    changeDisbursementAmt(val){
      let dis = this.DisbursementAccountList.filter(function(a){
        return a.eco_account_name == val
      })[0];

      let credit = this.credit    
      credit.eco_code_id = dis.id
      credit.eco_code = dis.eco_account_code
      credit.account_name = dis.eco_account_name;
    },

     /* {{this.EcoCodeInfoList}}*/
    changeEcoCode(val)
    {
      let eco = this.EcoCodeInfoList.filter(function(a){
        return a.id == val
      })[0];

      let debit = this.debit;
      debit.eco_code_id = eco.id
      debit.eco_code = eco.eco_account_code
      debit.account_name = eco.eco_account_name
    },


    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },

    previous(){
      this.$store.commit('UNSET_COMMON_DATA');
      this.$router.push("/on-lending/search-loan-reschedule");   
    },

    changeAmount(todayDisbursementAmount){
      let formSchema = this.formSchema
      let available_amount = Number(formSchema.available_amount);
      let todayPayAmount = Number(todayDisbursementAmount);

      if(available_amount < todayPayAmount)
      {
        formSchema.today_disbursement = 0;
        this.SnackbarVal.message = 'Today disbursement amount will be less than or equal of available amount';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "error"
      }
      this.setVoucherData();
    },

    numberFormate(numBer)
    {
      if(numBer != '-')
      {
        return Number(numBer).toFixed(2); 
        //return Number(numBer).toFixed(4);
        //return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      }
      else
      {
       return '0.00'; 
      }
    },

    setVoucherData(){

    let formSchema = this.formSchema;
    let debit = this.debit;
    let credit = this.credit;

    debit.tr_debit = formSchema.today_disbursement
    debit.tr_credit = 0
    debit.currency = formSchema.transaction_currency
    debit.bdt_debit = formSchema.today_disbursement
    debit.bdt_credit = 0
    debit.usd_debit = this.numberFormate(formSchema.today_disbursement / formSchema.currency_rate)
    debit.usd_credit = 0
    debit.src_fund = formSchema.fund_source
    debit.loan_no = formSchema.loan_no


    credit.tr_debit = 0
    credit.tr_credit = formSchema.today_disbursement
    credit.currency = formSchema.transaction_currency
    credit.bdt_debit = 0
    credit.bdt_credit = formSchema.today_disbursement
    credit.usd_debit = 0
    credit.usd_credit = this.numberFormate(formSchema.today_disbursement / formSchema.currency_rate)
    credit.src_fund = formSchema.fund_source
    credit.loan_no = formSchema.loan_no

    },

    required() {
      return v => !!v || 'Field is required';
    },

    changeOverdueAmt()
    {

      let formSchema = this.formSchema
      let dueAmount = formSchema.overdue_amount||0
      let downPayment = formSchema.down_payment||0
      this.checkNumber = downPayment>0 ? [this.required(),this.lng30] : [];
      //this.checkDateRequired = downPayment>0 ? 1 : 0;
      //(parseFloat(formSchema.outstanding_amount) - (parseFloat(downPayment)) + parseFloat(dueAmount)));
      formSchema.loan_amount = this.numberFormate(
        (parseFloat(formSchema.outstanding_amount) - (parseFloat(downPayment))));
    },

    ChangeInstType() {

      let instTypeVal = this.formSchema.installment_type_id
      console.log("instTypeVal = ", instTypeVal);
      if(instTypeVal>0)
      {
        let formSchema = this.formSchema;

        // let dividedVal = this.InstallmentTypeIdList.filter(function (a) 
        // {  
        //   return a.id === instTypeVal
        // })[0];

        // formSchema.no_of_installment =
        // Number(formSchema.repayment_period_in_month) / Number(dividedVal.year_divided);

        this.InstallmentTypeIdList.forEach(el => {
          if(el.id == instTypeVal){
            formSchema.no_of_installment = Number(formSchema.repayment_period_in_month) / Number(el.year_divided);
          }
        });

      }
      
    },

    printdiv: function () {
          this.printContentStatus = true;
          const divToPrint = document.getElementById("print-area");
          this.printContentStatus = false;
          const newWin = window.open("", "Print-Window");
          newWin.document.open();
          newWin.document.write(
              '<style type="text/css">'+
              'table.paySchedule{ width:100%; border-collapse: collapse; }'+
              '.paySchedule th{ border:1px solid #000; padding: 6px; }'+
              '.paySchedule td{ border:1px solid #000; padding: 6px; }'+
              '.paySchedule tr.tb-td td{font-weight: bold; text-align:center;}'+
              'td.textCenter{text-align: center;}'+
              'td.textRight{text-align: right;}'+
              '#prescriptions_bgImgs{position: absolute; left: 35%; background-repeat: no-repeat;'+
              'background-position: center; background-size: cover; opacity: 0.1; top: 30%; }.paySchedule tr.borderNone td,.paySchedule td.borderNone{border:none !important;}'+
              "</style>"
          );
          newWin.document.write(
              '<html><head><link rel="stylesheet" href="src/assets/css/style.css" type="text/css" /></head><body onload="window.print()">' +
              divToPrint.innerHTML +
              "</body></html>"
          );

          newWin.document.close();
          setTimeout(function () {
              newWin.close();
          }, 3000);
      },

   
  },

  computed:{
  }
};
</script>

<style scoped>
table.reSchedult{
  width:100%;
  border-collapse: collapse;
}
.reSchedult td{
  /*border: 1px solid #CCC;*/
  line-height: 31px;
  text-align: left;
}
.reSchedult tr.tb-td td{
  font-weight: bold;
}
td.textCenter{
  text-align: center;
}
td.textRight{
  text-align: right;
}
td input{
  width:100%;
  text-align: center;
}
table.paySchedule {
  width: 100%;
  border-collapse: collapse;
}
.paySchedule th{
  border: 1px solid #CCC;
  text-align: center;
  padding: 0px;
}

.paySchedule td{
  border: 1px solid #CCC;
  line-height: 33px;  
  text-align: center;
  padding: 0px;
}

.paySchedule tr.tb-td td {
  font-weight: bold;
}
.top {
  display: block;
}

</style>


// WEBPACK FOOTER //
// src/components/lending/loanReSchedule/insert_form.vue